import React from 'react';
import ConfigAccess from "../../components/Admin/ConfigAccess";

const ConfigAccessPage = () => {
  return <ConfigAccess />;
};

export default ConfigAccessPage;
